import { CONSTANT } from '@/constant/index'

class AuoReply {
  constructor(chatControl) {
    this.chatControl = chatControl
    this.isFirst = true
    this.interval = null
  }

  /**
   * 首次连接成功发送默认语
   */
  addInfoByFirst() {
    if (this.isFirst) {
      setTimeout(() => {
        this.chatControl.addInfoByReceive({
          title: CONSTANT.RECONNECT_SECOND_TIP
        }, true)
        this.isFirst = false
      }, 2 * 1000)
    }
  }

  /**
   * 客服未回消息自动回复
   */
  addInfoByNotReply() {
    if (this.interval) return
    this.interval = setInterval(() => {
      this.chatControl.addInfoByReceive({
        title: CONSTANT.NOT_REPLY_TIP
      }, true)
      clearInterval(this.interval)
      this.interval = null
    }, 60 * 1000)
  }

  /**
   * 清除客服未回消息自动回复
   */
  clearReply() {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  }
}

export default AuoReply


// WEBPACK FOOTER //
// ./src/controller/modules/autoReply.js